/* Nobi website prototype v3.0 — light-scene.js (extracted from index.html, 8 Oct 2026) */
  // C3: light scene (Claude Design, 3 Oct). site.js drives the moments (data-state + 'statechange');
  // this moves the sun/moon along a 24-hour sky, animates the clock and status, and follows the market: US 12h, UK 24h.
  (function () {
    const scene = document.getElementById('lightscene');
    if (!scene) return;
    const ORDER = ['morning', 'midday', 'evening', 'night', 'situp', 'walk', 'back'];
    const LABEL = { morning: ['07:00', 'Cooler light'], midday: ['12:00', 'Bright daylight'], evening: ['18:00', 'Warmer light'],
                    night: ['22:00', 'Light off'], situp: ['02:30', 'Soft glow'], walk: ['02:31', 'Path to the bathroom'], back: ['02:40', 'Light off'] };
    const $ = id => document.getElementById(id);
    const sun = $('ls-sun'), moon = $('ls-moon'), clockT = scene.querySelector('.clock-t'), clockAP = scene.querySelector('.clock-ap'), status = $('ls-status');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hour = s => { const p = LABEL[s][0].split(':'); return +p[0] + p[1] / 60; };
    const h24 = () => document.body.dataset.activeMarket === 'uk';
    const pad = n => String(n).padStart(2, '0');
    function fmt(t) {
      const m = Math.round((((t % 24) + 24) % 24) * 60) % 1440, hh = Math.floor(m / 60), mm = m % 60;
      return h24() ? [`${pad(hh)  }:${  pad(mm)}`, ''] : [`${(hh + 11) % 12 + 1  }:${  pad(mm)}`, hh < 12 ? 'AM' : 'PM'];
    }
    const tick = hh => { if (h24()) return `${pad(hh % 24 === 0 && hh ? 24 : hh)  }:00`; const k = hh % 24; return `${(k + 11) % 12 + 1  } ${  k < 12 ? 'AM' : 'PM'}`; };
    let h = hour(scene.dataset.state || 'morning'), shown = h, raf;
    function render() {
      const t = ((h % 24) + 24) % 24, day = t >= 6 && t <= 18;
      let a, x, y;
      if (day) { a = Math.PI * (1 - (t - 6) / 12); x = 180 + 90 * Math.cos(a); y = 62 - 52 * Math.sin(a); }
      else if (t > 18) { a = Math.PI - (Math.PI / 2) * ((t - 18) / 6); x = 360 + 90 * Math.cos(a); y = 62 - 30 * Math.sin(a); }
      else { a = (Math.PI / 2) * (1 - t / 6); x = 90 * Math.cos(a); y = 62 - 30 * Math.sin(a); }
      const at = `translate(${  x.toFixed(2)  } ${  y.toFixed(2)  })`;
      sun.setAttribute('transform', at); moon.setAttribute('transform', at);
      sun.setAttribute('visibility', day ? 'visible' : 'hidden'); moon.setAttribute('visibility', day ? 'hidden' : 'visible');
      const c = fmt(shown); clockT.textContent = c[0]; clockAP.textContent = c[1];
      scene.querySelectorAll('[data-tick]').forEach(el => { el.textContent = tick(+el.dataset.tick); });
    }
    function go(s) {
      status.textContent = LABEL[s][1];
      const from = h, target = hour(s);
      let d = ((target - from) % 24 + 24) % 24; if (d > 12) d -= 24;
      cancelAnimationFrame(raf);
      if (reduce || Math.abs(d) < 1e-6) { h = from + d; shown = target; render(); return; }
      const t0 = performance.now(), dur = 2800;   /* half speed (was 1400) */
      (function step(now) {
        const k = Math.min(1, (now - t0) / dur), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
        h = from + d * e; shown = k < 1 ? h : target; render();
        if (k < 1) raf = requestAnimationFrame(step);
      })(t0);
    }
    scene.addEventListener('statechange', e => go(e.detail));
    new MutationObserver(render).observe(document.body, { attributes: true, attributeFilter: ['data-active-market'] });
    go(scene.dataset.state || ORDER[0]);
  })();
